<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="20">
        <el-input
          v-model="searchText"
          clearable
          placeholder="Search"
          prefix-icon="el-icon-search"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :span="4">
        <div style="text-align: right">
          <el-tooltip :content="`Add new hook`">
            <i class="fa fa-plus-circle filter-btn filter-add" @click="handleCreate"></i>
          </el-tooltip>
          <el-tooltip content="Clear filters">
            <i class="fa fa-times-circle filter-btn filter-clear" @click="handleResetFilters"></i>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
    <draggable
      id="draggable-hook"
      class="draggable-group"
      draggable=".draggable"
      v-model="hookQuestions"
      v-infinite-scroll="handleLoadMore"
      :body-style="{ padding: '0' }"
      :class="{ 'draggable-fixed': isFixed }"
      :group="{ name: 'hooks', pull: 'clone', put: false }"
      :sort="false"
    >
      <div
        class="item"
        v-for="item in hookQuestions"
        :key="item.id"
        :class="{
          draggable: !isDisabled(item.id) && isEditable,
          enabled: !isDisabled(item.id),
          disabled: isDisabled(item.id),
        }"
      >
        <el-card
          style="margin: 4px 0"
          shadow="never"
          :key="item.id"
          :body-style="itemStyle(item.id)"
          @click.native="handleSelect(item)"
          @dblclick.native="handleAddItem(item)"
        >
          <div class="handle pull-right">
            <i class="fa fa-ellipsis-v"></i>
            <i class="fa fa-ellipsis-v"></i>
          </div>
          <div class="options pull-right">
            <a @click="handleEditItem(item)">
              <i class="fa fa-pencil"></i>
            </a>
          </div>
          <div class="hook-item">
            <hook-media :hook="item.mediaClip"></hook-media>
          </div>
          <div class="clearfix"></div>
        </el-card>
      </div>
      <empty v-if="hookQuestions.length === 0">No hooks found.</empty>
    </draggable>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters, mapState } from 'vuex';

import draggable from 'vuedraggable';

import infiniteScroll from 'vue-infinite-scroll';
import Empty from '@/components/common/Empty';
import HookMedia from '@/components/surveybuilder/editors/music/HookMedia';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

const DEBOUNCE_DELAY = 600;

export default {
  name: 'HookSelector',
  components: {
    draggable,
    Empty,
    HookMedia,
  },
  directives: { infiniteScroll },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    disabledIds: [],
  }),
  computed: {
    ...mapGetters('surveybuilder', ['hookQuestions']),
    ...mapState('surveybuilder', ['hooksLoading', 'hooksPage', 'selectorHookSearchText']),

    searchText: {
      get() {
        return this.selectorHookSearchText;
      },
      set(text) {
        this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_SELECTOR_HOOK_TEXT}`, text);
        this.handleDebounceGetHooks();
      },
    },
  },
  methods: {
    isDisabled(itemId) {
      return this.disabledIds.includes(itemId);
    },

    itemStyle(itemId) {
      const style = { padding: '8px' };
      if (this.isDisabled(itemId)) {
        return { ...style, color: '#ccc', backgroundColor: '#eee', fontStyle: 'oblique' };
      }

      return style;
    },

    handleCreate() {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_HOOK_DIALOG_VISIBILITY}`, true);
    },

    handleEditItem(item) {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_HOOK_DIALOG_FORM}`, item);
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_HOOK_DIALOG_VISIBILITY}`, true);
    },

    handleResetFilters() {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.RESET_SELECTOR_HOOK_FILTERS}`);
      this.$store.dispatch('surveybuilder/getHooks');
    },

    // eslint-disable-next-line
    handleDebounceGetHooks: debounce(function() {
      this.$store.dispatch('surveybuilder/getHooks');
    }, DEBOUNCE_DELAY),

    handleLoadMore() {
      if (this.hookQuestions.length && !this.hooksLoading) {
        this.$store.dispatch('surveybuilder/getMoreHooks');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';

.handle {
  text-align: right;
  width: 2em;
  cursor: grab;
  color: #ccc;
}

.options {
  cursor: pointer;
  color: #ccc;
}

.options a {
  color: #ccc;
}

.draggable-group {
  overflow: auto;
  min-height: 225px;
  height: calc(100vh - 460px);
}

.draggable-fixed {
  height: calc(100vh - 250px);
}


.filter-btn {
  font-size: 20px;
  margin: 4px 2px;
  cursor: pointer;
}

.filter-add {
  color: $colony-green;
}

.filter-clear {
  color: $colony-red;
}
</style>



// WEBPACK FOOTER //
// HookSelector.vue?681f6875